import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';

//import components
import LoadingIndicator from '../components/LoadingIndicator.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import AboutHeadingsPage from '../components/characteristics/AboutHeadingsPage.js';
import HeadingsStrucutre from '../components/characteristics/HeadingsStrucutre.js';
import HeadingsTitleSearchForm from '../components/characteristics/HeadingsTitleSearchForm.js';
import HeadingsTitleSearchResults from '../components/characteristics/HeadingsTitleSearchResults.js';
import Error505Page from '../components/Error505Page.js';

//import helper methods
import withTitle from '../scripts/WithTitle.js';
import * as CheckPathname from '../scripts/CheckPathname.js';

class CharacterHeadings extends Component {
	constructor() {
		super();

		this.state = {
			fireRedirect: false,
			isWrongQuery: false,
			query: '',
		};
	};

	componentDidMount() {
		const { actions, clang, rootsData, dataAbout, location, resultsList } = this.props;
		const query = queryString.parse(location.search);
		if (!resultsList) {
			this.updateResultsList(query);
		}

		if (!dataAbout) {
			actions.getHeadingsAbout(clang);
		}

		if (!rootsData) {
			actions.getHeadingsRoots();
		}

	};

	componentDidUpdate(prevProps, prevState) {
		const { actions, clang, location } = this.props;

		if (clang !== prevProps.clang) {
			actions.getHeadingsAbout(clang);
		}

		if (prevProps.location !== location) {
			this.setState({ fireRedirect: false });

			const nextQuery = queryString.parse(location.search);
			this.updateResultsList(nextQuery);
		}
	};

	componentWillUnmount() {
		const { actions } = this.props;
		actions.resetHeadingsSearchKey();
	};

	getHeadingChildren = (name) => {
		const { actions } = this.props;

		actions.getHeadingChildren(name);
	};

	getFieldChildren = (id) => {
		const { actions } = this.props;

		actions.getFieldChildren(id);
	};

	submitForm = (values) => {
		const { location, history } = this.props;

		if (CheckPathname.isHeadingsSearch(location)) {
			history.push({
				search: `?q=${values.key.trim()}`,
			});
		} else {
			this.setState({
				fireRedirect: true,
				query: values.key.trim()
			});
		}
	};

	updateResultsList = (query) => {
		const { actions, location } = this.props;

		this.setState({ isWrongQuery: false });

		if (query.q && query.q.trim()) {
			actions.fetchHeadingsTitleResults(query.q.trim());
		} else {
			if (CheckPathname.isHeadingsSearch(location)) {
				this.setState({ isWrongQuery: true });
			}
		}
	};

	render() {
		const { isLoadingAboutError, isLoadingAbout, clang, dataAbout, rootsData, isLoadingRootsError,
			isLoadingRoots, isLoadingHeadingChildren, isLoadingHeadingChildrenError, match, currentKey, titleHeadingsSearchParams,
			location, titleResults, isLoadingErrorTitleResults, isFetchingHeadingTitleResults } = this.props;
		const { fireRedirect, query, isWrongQuery } = this.state;
		const breadcrumbsList = [ { label: 'home' }, { label: 'headings', link: '/headings' } ];
		const from = location.state || '/';

		const reduceByAdding = (arr) => {
			return arr.reduce(function (previousValue, currentValue) {
				return previousValue + currentValue;
			});
		};

		const getTotalCount = () => {
			if (!titleResults) {
				return;
			}

			if (titleResults.length < 1) {
				return 0;
			}

			return reduceByAdding(titleResults.map(titleResults => reduceByAdding(titleResults.headings.map(resultHeading => resultHeading.recordsNumber))));
		};

		const headingsResultsTitle = `${lang[ clang ].characteristics.search_results_title} (${getTotalCount()})`;

		return (
			<section className="character-headings">

				{ !isLoadingAbout && !isLoadingAboutError && dataAbout && !isLoadingRootsError && location.pathname !== `${match.url}/search` &&
					<div>
						<ItemBreadcrumbs list={ breadcrumbsList } currentPage={ lang[ clang ].characteristics[ 'headings' ] } />
						<AboutHeadingsPage title={ dataAbout.acf.departments_characteristic_title }
							desc={ dataAbout.acf.departments_characteristic_desc }
							onSubmit={ this.submitForm }
							isWrongQuery={ isWrongQuery }
							isLoading={ isFetchingHeadingTitleResults }
							isError={ isLoadingErrorTitleResults } />
					</div> }

				{ location.pathname === `${match.url}/search` &&
					<div className="headings-results__breadcrumbs">
						<ItemBreadcrumbs list={ breadcrumbsList } currentPage={ lang[ clang ].characteristics[ 'headings_results' ] } />
						<h3 className="headings-results__header" dangerouslySetInnerHTML={ { __html: headingsResultsTitle } }></h3>
					</div> }

				{ !isWrongQuery && !isFetchingHeadingTitleResults && !isLoadingErrorTitleResults && !isLoadingRootsError && !isLoadingRoots &&
					<div className="character-headings__form">
						<HeadingsTitleSearchForm
							onSubmit={ this.submitForm }
							initialValues={ { key: titleHeadingsSearchParams.key } }
							currentKey={ currentKey[ 'headings-title-search' ] ? currentKey[ 'headings-title-search' ].values.key : false } />
					</div> }

				{ isLoadingRoots && !isLoadingRootsError &&
					<LoadingIndicator /> }

				{ isLoadingRootsError &&
					<div className="headings-structure">
						<Error505Page />
					</div> }

				{ !isLoadingRoots && !isLoadingRootsError &&
					<Route exact path={ `${match.url}` }
						render={ () =>
							<HeadingsStrucutre
								data={ rootsData }
								getHeadingChildren={ this.getHeadingChildren }
								getFieldChildren={ this.getFieldChildren }
								isLoading={ isLoadingHeadingChildren }
								isError={ isLoadingHeadingChildrenError } /> }
					/> }

				<Route path={ `${match.url}/search` }
					render={ () =>
						<HeadingsTitleSearchResults
							isWrongQuery={ isWrongQuery }
							results={ titleResults }
							isLoading={ isFetchingHeadingTitleResults }
							isError={ isLoadingErrorTitleResults }
							searchKey={ titleHeadingsSearchParams.key } />
					}
				/>

				{ location.pathname !== `${match.url}/search` &&
					<Route path={ `${match.url}/:id` } component={ () => <Redirect to={ `${match.url}` } /> } /> }

				{ fireRedirect &&
					<Redirect push to={ {
						pathname: `${match.url}/search`,
						search: `?q=${query}`,
						state: {
							referrer: from
						}
					} } /> }
			</section>
		);
	};
};

CharacterHeadings.propTypes = {
	actions: propTypes.object.isRequired,
	isLoadingAbout: propTypes.bool.isRequired,
	isLoadingAboutError: propTypes.bool.isRequired,
	isLoadingRoots: propTypes.bool.isRequired,
	isLoadingRootsError: propTypes.bool.isRequired,
	isLoadingHeadingChildren: propTypes.object.isRequired,
	isLoadingHeadingChildrenError: propTypes.object.isRequired,
	titleHeadingsSearchParams: propTypes.object.isRequired,
	dataAbout: propTypes.shape({
		acf: propTypes.object
	}),
	rootsData: propTypes.array
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
	dataAbout: state.characteristics.aboutHeadingsData,
	rootsData: state.characteristics.rootsHeadingsData,
	isLoadingAbout: state.characteristics.isFetchingHeadingsAbout,
	isLoadingAboutError: state.characteristics.isLoadingErrorHeadingsAbout,
	isLoadingRoots: state.characteristics.isFetchingHeadingsRoots,
	isLoadingRootsError: state.characteristics.isLoadingErrorHeadingsRoots,
	isLoadingHeadingChildren: state.characteristics.isFetchingHeadingChildren,
	isLoadingHeadingChildrenError: state.characteristics.isLoadingErrorHeadingChildren,
	titleHeadingsSearchParams: state.characteristics.titleHeadingsSearchParams,
	currentKey: state.form,
	isFetchingHeadingTitleResults: state.characteristics.isFetchingHeadingTitleResults,
	isLoadingErrorTitleResults: state.characteristics.isLoadingErrorTitleResults,
	titleResults: state.characteristics.titleResults,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
	withTitle,
);

export default enhance(CharacterHeadings);



// WEBPACK FOOTER //
// ./src/containers/CharacterHeadings.js